import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import type { ZuubManualCheckListResponse } from '@/@types/zuub/contracts';

import { makeAPIRequestReactQueryWithHeaders } from '../api';
import { endpoints } from '../endpoints';

/**
 * Fetches the manual-check list (recent verifications) for the current practice/org.
 * Uses Practice and Org headers. Only runs when practice and org are present.
 */
export const useZuubManualCheckList = (options?: {
  refetchInterval?: number | false;
  page?: number;
  limit?: number;
}) => {
  const {
    primaryPracticeId: practiceId,
    primaryOrganizationId: organizationId,
  } = useSelector(
    (state: {
      login: {
        user: {
          primaryPracticeId?: string;
          primaryOrganizationId?: string;
        };
      };
    }) => state.login.user,
  );

  return useQuery<ZuubManualCheckListResponse>(
    [endpoints.zuubManualCheckList, options?.page ?? 1, options?.limit ?? 10],
    () =>
      makeAPIRequestReactQueryWithHeaders<ZuubManualCheckListResponse>(
        endpoints.zuubManualCheckList,
        {
          page: options?.page ?? 1,
          limit: options?.limit ?? 10,
        },
        {
          Org: organizationId,
          Practice: practiceId,
        },
        'GET',
      ),
    {
      enabled: Boolean(practiceId && organizationId),
      refetchInterval: options?.refetchInterval,
    },
  );
};
